import React, { Component } from "react";
import { Button, Form, Modal, Row, Alert, } from "antd";
import CloseIcon from "../../assets/fi_x-circle.svg";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";
import { moveMultiSelectedAsset } from "../../actions/ClientAction";

class MultiMoveModal extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    const { folderselect } = this.props;
    if (folderselect && folderselect !== "") {
      this.setState({
        folderId: folderselect
      });
    }
  }

  handleFolderSelect = folderId => {
    this.setState({
      folderId
    });
    if (this.props.handleFolderSelect) {
      this.props.handleFolderSelect(folderId);
    }
  };

  handleMultiMove = () => {
    const {
      moveMultiSelectedAsset,
      keyCollection,
      workclient,
      selectedFiles,
      folderselect,
      page,
      intl,
      limit,
      items,
    } = this.props;

    const { folderId } = this.state;

    if (selectedFiles.length > 0 && items === undefined) {
      const ids = selectedFiles.map(e => e._id);
      moveMultiSelectedAsset(
        keyCollection,
        workclient,
        ids,
        folderId,
        folderselect,
        page,
        intl,
        limit
      );
    } else if (items.length > 0 && items !== undefined) {
      moveMultiSelectedAsset(
        keyCollection,
        workclient,
        items,
        folderId,
        folderselect,
        page,
        intl,
        limit
      );
    }
  };

  render() {
    const {
      showModal,
      handleHiddenModal,
      selectedFiles,
      items,
      intl,
      user,
      isMoving,
      handleMultiMove,
    } = this.props;
    const isOperator = user.role !== "admin" && user.clientRole !== "admin";
    const totalFiles = selectedFiles.length > 0 ? selectedFiles : items;

    const { folderId } = this.state;

    return (
      <Modal
        visible={showModal}
        onCancel={handleHiddenModal}
        width={500}
        footer={null}
        centered
        closeIcon={<img src={CloseIcon} alt={"icon close"} />}
        className="move-modal"
      >
        <div className="move-modal-title">
          {intl.formatMessage({id: "move_asset"})}
        </div>
        <div
          style={{
            color: "#6F6F6F",
            fontSize: 18,
            fontWeight: 400,
            marginBottom: 10
          }}
        >
          {intl.formatMessage({id: "multi-move-move"})} {totalFiles.length}{" "}
          {totalFiles.length === 1 ? intl.formatMessage({id: "multi-share-sharing-item"}) : intl.formatMessage({id: "multi-share-sharing-items"})}
        </div>

        <div style={{ marginTop: 24, fontSize: 18,}}>
          <Form>
            <Form.Item>
              <Breadcrumb
                title={intl.formatMessage({ id: "breadcrumb_placeholder" })}
                placeholder={intl.formatMessage({
                  id: "move_asset_placeholder"
                })}
                value={folderId}
                handleFolderSelect={this.handleFolderSelect}
                permissionAware={
                  user.clientRole === "admin" || user.role === "admin"
                    ? false
                    : true
                }
                permissionsArray={["move"]}
              />
            </Form.Item>
          </Form>
        </div>
        <Form.Item>
          {!isOperator && (
            <Alert
              message={intl.formatMessage({ id: "warning" })}
              description={intl.formatMessage({
                id: "crudfolder_move_warnings_message"
              })}
              type="warning"
              showIcon
            />
          )}
        </Form.Item>
        <Row type={"flex"} justify={"space-between"}>
          <Button
            size={"large"}
            type={"primary"}
            onClick={() =>
              handleMultiMove ? handleMultiMove() : this.handleMultiMove()
            }
            loading={isMoving}
            className="move-modal-button accept"
          >
            {intl.formatMessage({id: "move_asset"})}
          </Button>
          <Button
            size={"large"}
            type={"primary"}
            ghost
            onClick={handleHiddenModal}
            className="move-modal-button cancel"
          >
            {intl.formatMessage({id: "cancel_button"})}
          </Button>
        </Row>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    workclient: state.client.workclient,
    selectedFiles: state.selectedFiles.data,
    user: state.authUser.user,
    folderselect: state.assetsExplore.folderselect,
    page: state.assetsExplore.page,
    limit: state.assetsExplore.limit,
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
  };
};

const mapDispatchToProps = {
  moveMultiSelectedAsset
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(MultiMoveModal))
);
